import TitleRed from "../../images/who-we-are/title-bg.svg";
import BgIcon from "../../images/gallery/bg-icon.png";
import workspace1 from "../../images/gallery/workspace 1 .jpg";
import workplace2 from "../../images/gallery/workplace 2.jpg";
import workplace3 from "../../images/gallery/workplace 3.jpg";
import workplace4 from "../../images/gallery/workplace 4.jpg";



function Gallery() {
  return (
    <>
      <section id="gallery" className="relative min450:hidden">
        <img
          src={BgIcon}
          alt="bg_img"
          className="absolute top-[30px] right-0"
        />

        <div className="container page-padding py-[4rem]">
          {/* title div */}
          <div className="flex flex-col text-center relative items-center">
            <p className="text-white relative z-10 text-[15px] uppercase font-bold mb-10">
              GYM GALLERY
            </p>
            <img
              src={TitleRed}
              alt="text_bg"
              className="w-[23rem] absolute -top-[10px]"
            />

            <h2 className="text-[3.4rem] font-bold mb-4">
              Our Workplace Gallery
            </h2>
            <p className="text-[#646464] font-medium text-[18px]"> 
  Experience a dynamic atmosphere where fitness meets professional guidance and innovation.
</p>

            
          </div>

          {/* gallery */}
          <div className="grid grid-cols-2 gap-12 w-full">
            <div
              id="item-0"
              className="flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300"
            >
              <img
                src={workspace1}
                alt="Workplace 1"
                className="w-100 h-80 rounded-lg shadow-lg mb-4"
              />
             <p className="text-xl font-bold running-text text-[#e63946, #ff69b4]">
  A Dynamic Atmosphere That Fuels Your Fitness Journey
</p>

            </div>

            <div
              id="item-1"
              className="flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300"
            >
              <img
                src={workplace2}
                alt="Workplace 2"
                className="w-100 h-80 rounded-lg shadow-lg mb-4"
              />
              <p className="text-xl font-bold running-text text-[#e63946, #ff69b4]">
              Elevating Performance with Cutting-Edge Equipment
              </p>
            </div>

            <div
              id="item-2"
              className="flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300"
            >
              <img
                src={workplace3}
                alt="Workplace 3"
                className="w-100 h-80 rounded-lg shadow-lg mb-4"
              />
             
              <p className="text-xl font-bold running-text text-[#e63946, #ff69b4]">
              Where Every Workout Leads to Achievement and Growth              </p>
            </div>

            <div
              id="item-3"
              className="flex flex-col items-center text-center transform hover:scale-105 transition-transform duration-300"
            >
                <img
                src={workplace4}
                alt="Workplace 4"
                className="w-100 h-80 rounded-lg shadow-lg mb-4"
              />

      
              <p className="text-xl font-bold running-text text-[#e63946, #ff69b4]">
                Spaces Designed for Maximum Productivity
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;